import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditLayoutMappingsForm = (_strings: any, layouts: any[] = []): FormModel[] => {
  return [
    {
      label: 'BBR Layout',
      value: '',
      size: 'medium',
      type: 'select',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'Select BBR layout',
      field: 'layout',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: layouts,
    },
    {
      label: 'IDS Layout Name',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS layout name',
      field: 'layoutName',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: 'IDS Layout Code',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS layout code',
      field: 'layoutCode',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
